import MeasurementsView from "components/MeasurementsView";
import HelpFloatingButtonV2 from "components/HelpFloatingButtonV2";

function ManageLoadsForecast() {
  return (
    <>
      <HelpFloatingButtonV2 helpScreen="loads" />
      <MeasurementsView initialSide="forecast" />
    </>
  );
}

export default ManageLoadsForecast;
